module.exports = __webpack_public_path__ + "img/poster.efaf0522.jpg";